import classes from "./Kegel.module.css";
import React from "react";
import Button from "../../components/UI/Button/Button";
import instance from "../../store/AxiosInterceptor";
import { useLoaderData, useNavigate } from "react-router-dom";

function LaneMachinesDetail(props) {
    const resData = useLoaderData();
    // const menuName = useLoaderData();

    const navigate = useNavigate();
    const kegelData = useLoaderData();

    const kegelTypeMapping = {
        MACHINE: "machine",
        CONSUMABLE: "consumable",
        TOOL: "training_materials",
    };

    const mappedKegelType =
        kegelTypeMapping[kegelData.kegelType] || kegelData.kegelType;

    const toList = () => {
        navigate(`/kegel/${mappedKegelType}`);
    };
    // const breadCrumbList = ["케겔", mappedKegelType];
    return (
        <>
            {/* <BreadCrumb breadCrumbList={breadCrumbList} />( */}
            <div className={classes.contents_wrap}>
                <div className={classes.contents_detail}>
                    <div className={classes.contents_title}>
                        <div className={classes.img_box}>
                            <img
                                src={kegelData.attach_uri}
                                alt="laneMachine 이미지"
                            />
                        </div>
                        <div className={classes.contents_info}>
                            <div className={classes.title}>
                                {/* <p className={classes.en}>IKON</p> */}
                                <h3>{kegelData.title}</h3>
                            </div>
                            <div className={classes.contents}>
                                <ul>
                                    <li>{kegelData.firstSignature}</li>
                                    <li>{kegelData.secondSignature}</li>
                                    <li>{kegelData.thirdSignature}</li>
                                    {/* <li>항목명 #1 : 스펙내용이 들어갑니다.</li>
                                    <li>항목명 #2 : 스펙내용이 들어갑니다.</li>
                                    <li>항목명 #3 : 스펙내용이 들어갑니다.</li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className={classes.detail_box}>
                        {/* <img
                            src={laneMachine_lift}
                            alt="laneMachine lift 이미지"
                        /> */}
                        <div>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: kegelData.content,
                                }}
                            />
                        </div>
                    </div>
                    <div className={classes.btn_wrap} onClick={toList}>
                        <Button>목록</Button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LaneMachinesDetail;

export const loader = async ({ params }) => {
    try {
        const response = await instance.get(
            `/api/v1/home/kegel/${params.kegelId}/info`
        );

        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error("Failed to fetch data");
        }
    } catch (error) {
        console.error("Error fetching data:", error);
        return null;
    }
};
